
export default {
  props: {
    address: {
      type: Object,
      default: () => {},
    },
    billing: {
      type: Boolean,
      default: true,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      enableTaxNumber: process.env.REGION === 'PT',
    };
  },
};
